import { render, staticRenderFns } from "./sso-setup.vue?vue&type=template&id=25048df5&"
import script from "./sso-setup.ts?vue&type=script&lang=ts&"
export * from "./sso-setup.ts?vue&type=script&lang=ts&"
import style0 from "./sso-setup.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports